import React, { useState, useEffect } from 'react';

import {  useFetchEntity } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';
import { useFormikContext } from 'formik';
import { useEdit } from '../../Services/EditContext';
import { FormLabel, FormValue } from './FormLabel';
import ErrorMessage from './ErrorMessage'
import Selector from './Selector';

const EntityStatusSelector = ({ entityType, id,label }) => {
    const { values, setFieldValue } = useFormikContext();
    const [statusDetail, loadingStatus, loadingStatusError] = useFetchEntity({ name: "AllowedActions", getByStatus: () => values[entityType] ? endpoints.getStatusForEntity + values[entityType] + '/' : null });
    const [options, setOptions] = useState(null);
    const [selection, setSelection] = useState(null);
    const [edit] = useEdit();
    useEffect(() => {
        const newOptions = statusDetail ? statusDetail.map((d) => { return { value: d.entityState, label: d.entityState } }) : [];
        setOptions(newOptions);
    }, [statusDetail]);
    useEffect(() => {
        if (options) {
            const newSelection = options.find((x) => { return x.value === values[id] });
            if (newSelection) {
                setSelection(newSelection);
                setFieldValue(id, values[id]);
            }
        
        }
    },[options,values,id,setFieldValue])
    const onSelect = (e) => {
        setFieldValue(id, e.value);
    }
    return <React.Fragment>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>
        {!loadingStatus && !loadingStatusError && edit ?
            <Selector onChange={onSelect} options={options} value={selection} /> : <FormValue> {values[id]}</FormValue>}
        <ErrorMessage name={id} />
    </React.Fragment>
     
}


export default EntityStatusSelector;